export default __webpack_public_path__ + "static/media/Fullstack Ecommerce.559d8155.jpg";